/**
* Appointment CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Appointment CTA component.
*/

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    className: 'appointment-cta',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
    },
    finalize: function() {
      const sections = document.querySelectorAll( this.selector() );

      sections.forEach( ( section ) => {
        const leftImage = section.querySelector( '.appointment-cta__left' );
        const rightImage = section.querySelector( '.appointment-cta__right' );

        if ( leftImage ) {
          gsap.from( leftImage, {
            y: 50,
            opacity: 0,
            duration: 1,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: section,
              start: 'top 80%',
              toggleActions: 'play none none none',
            },
          } );
        }

        if ( rightImage ) {
          gsap.from( rightImage, {
            y: 50,
            opacity: 0,
            duration: 1,
            ease: 'power2.out',
            delay: 0.35,
            scrollTrigger: {
              trigger: section,
              start: 'top 80%',
              toggleActions: 'play none none none',
            },
          } );
        }
      } );
    },
  };
  app.registerComponent( 'appointment-cta', COMPONENT );
} )( app );
